import {
  FiArrowRight,
  FiHeart,
  FiBookOpen,
  FiActivity,
  FiUsers,
  FiShield,
  FiDroplet,
} from "react-icons/fi";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Causes() {
  const { t } = useTranslation();

  const themes = [
    {
      title: t("causes.emergency.title"),
      description: t("causes.emergency.description"),
      image: "/images/emargency-relief.jpg",
      icon: FiShield,
      color: "from-red-500 to-red-600",
    },
    {
      title: t("causes.education.title"),
      description: t("causes.education.description"),
      image: "/images/projects/education.jpg",
      icon: FiBookOpen,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: t("causes.healthcare.title"),
      description: t("causes.healthcare.description"),
      image: "/images/healthcare.jpg",
      icon: FiActivity,
      color: "from-green-500 to-green-600",
    },
    {
      title: t("causes.livelihoods.title"),
      description: t("causes.livelihoods.description"),
      image: "/images/agriculture.jpg",
      icon: FiUsers,
      color: "from-purple-500 to-purple-600",
    },
    {
      title: t("causes.foodSecurity.title"),
      description: t("causes.foodSecurity.description"),
      image: "/images/livlyhood.jpg",
      icon: FiHeart,
      color: "from-orange-500 to-orange-600",
    },
    {
      title: t("causes.wash.title"),
      description: t("causes.wash.description"),
      image: "/images/water.jpg",
      icon: FiDroplet,
      color: "from-cyan-500 to-cyan-600",
    },
    {
      title: t("causes.childWelfare.title"),
      description: t("causes.childWelfare.description"),
      image: "/images/child.jpg",
      icon: FiHeart,
      color: "from-pink-500 to-pink-600",
    },
  ];
  return (
    <div className="px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-green-800 mb-6">
            {t("causes.title")}
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            {t("causes.subtitle")}
          </p>
        </div>

        {/* Causes Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {themes.map((theme, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100"
            >
              {/* Image Container */}
              <div className="relative h-64 overflow-hidden">
                <img
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  src={theme.image}
                  alt={theme.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

                {/* Icon Badge */}
                <div
                  className={`absolute top-4 right-4 w-12 h-12 bg-gradient-to-r ${theme.color} rounded-full flex items-center justify-center shadow-lg`}
                >
                  <theme.icon className="w-6 h-6 text-white" />
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-green-800 mb-4 group-hover:text-green-700 transition-colors duration-300">
                  {theme.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6 line-clamp-4">
                  {theme.description}
                </p>

                {/* CTA Button */}
                <Link className="inline-flex items-center space-x-2 text-green-600 hover:text-green-800 font-semibold transition-colors duration-300 group-hover:translate-x-2 transform">
                  <span>{t("causes.learnMore")}</span>
                  <FiArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <button className="bg-green-800 hover:bg-green-700 text-white font-semibold px-8 py-4 rounded-lg text-lg transition-all duration-300 transform hover:scale-105 shadow-lg">
            {t("causes.supportButton")}
          </button>
        </div>
      </div>
    </div>
  );
}
